import React, {useMemo, useState} from 'react';
import {CardProps} from "../../types/types";
import classes from "./Card.module.css";
import {RAIL_VIEW} from "../../consts/viewType";
import {DEFAULT_CONFIG} from "../../consts/config";
import classNames from "classnames";
import {triggerEvent} from "../../utils/eventRegistry";

const Card: React.FC<CardProps> = (props) => {

    const [isHighlightedCard, setIsHighlightedCard] = useState(false);

    const card = useMemo(()=>{
        return props.card;
    },[props.card])

    const config = useMemo(()=>{
        return props.config;
    },[props.config])


    const cardStyle = useMemo(()=>{
        if(props.config.viewType === RAIL_VIEW){
          return {
              height: config.railCardHeight ? config.railCardHeight + 'px': '200px',
              width: config.railCardWidth ? config.railCardWidth + 'px': '100%',
          }
        }else{
            return {
                height: config.tileCardHeight ? config.tileCardHeight + 'px': '200px',
                width: config.tileCardWidth ? config.tileCardWidth + 'px': '200px'
            }
        }
    },[props.config.viewType, config.railCardHeight, config.railCardWidth, config.tileCardHeight, config.tileCardWidth])

    const cardTemplate = useMemo(()=>{
        if(props.config.viewType === RAIL_VIEW){
            return config.railCardTemplate ? config.railCardTemplate : DEFAULT_CONFIG.railCardTemplate;
        }else{
            return config.tileCardTemplate ? config.tileCardTemplate : DEFAULT_CONFIG.tileCardTemplate;
        }
    },[props.config.viewType, config.tileCardTemplate, config.railCardTemplate])

    function handleDoubleClick() {
        triggerEvent('OnCardDoubleClick', card.id);
        setIsHighlightedCard(true);

        setTimeout(() => {
            setIsHighlightedCard(false);
        }, 300);
    }

    return (
        <div className={classNames(classes.card, props.className && classes[props.className])}
             style={cardStyle} dangerouslySetInnerHTML={{ __html: cardTemplate ? cardTemplate(card) : ''}}
             onDoubleClick={handleDoubleClick} data-highlighted={isHighlightedCard}>
        </div>
    );
};

export default Card;